"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var react_portal_1 = require("react-portal");
var Dimmer_1 = require("../Dimmer");
var ClickOutsideDetector_1 = require("../ClickOutsideDetector");
var react_spring_1 = require("react-spring");
var Modal = function (_a) {
    var style = _a.style, className = _a.className, open = _a.open, children = _a.children, onClose = _a.onClose;
    return (React.createElement(react_portal_1.Portal, null,
        React.createElement(react_spring_1.Transition, { items: Boolean(open), from: { opacity: 0 }, enter: { opacity: 1 }, leave: { opacity: 0 } }, function (toggle) {
            return toggle &&
                (function (_a) {
                    var opacity = _a.opacity;
                    return (React.createElement(react_spring_1.animated.div, { style: { pointerEvents: !open ? 'none' : undefined } },
                        React.createElement(Dimmer_1.default, { component: react_spring_1.animated.div, style: { opacity: opacity } }),
                        React.createElement("div", { className: styles.container },
                            React.createElement("div", { className: styles.wrap },
                                React.createElement(ClickOutsideDetector_1.default, { className: styles.clickOutDetector, onClickOutside: onClose },
                                    React.createElement(react_spring_1.Spring, { from: { scale: 0.25 }, to: { scale: open ? 1 : 0.25 } }, function (_a) {
                                        var scale = _a.scale;
                                        return (React.createElement(react_spring_1.animated.div, { style: __assign({}, style, { opacity: opacity, transform: "scale(" + scale + ")" }), className: classNames(styles.modal, className) }, children));
                                    }))))));
                });
        })));
};
exports.default = Modal;
